module.exports = __webpack_public_path__ + "media/images/test_vya-c64fecc043d48b9adcdf3ffcee85f5c4.png";